import { ENDOSO, POLIZA } from "../data/constants";
import { ramos_nombres } from "../data/data";
import { cantMonthsBetweenDates, formatDate } from "../utils/utils";

const adapterSegurosFromApi = (seguros_from_api) => {
    if (!seguros_from_api) return [];

    const { seguros } = seguros_from_api;

    return seguros.map((seguro) => {
        const {
            codSeguro,
            nroSeguro,
            nroEndoso,
            ramo,
            cancelada,
            codEstSeg,
            desdePoliza,
            hastaPoliza,
            desdeEndoso,
            hastaEndoso,
			emitidoSeguro,
            detalleAsegurado,
            nroProductor,
            nombreProductor,
            titular,
            nroSocio,
            socioProvincia,
            socioDivision,
            socioLocalidad,
            socioDireccion,
            socioDireccionDto,
            socioDireccionPiso,
            socioDireccionNumero,
            premio,
            prima,
            cuota1,
            cuotaX,
            cantidadCuotas,
            tipoPago,
            sumaAseguradaTotal,
            cantDiasVigenciaPoliza,
            cantDiasVigeciaRestantesPoliza,
            cantDiasVigenciaEndoso,
            cantDiasVigeciaRestantesEndoso,
        } = seguro;

        const isEndoso = nroEndoso !== 0;

        let fechaDesde = isEndoso ? desdeEndoso : desdePoliza;
        let fechaHasta = isEndoso ? hastaEndoso : hastaPoliza;

        fechaDesde = formatDate(fechaDesde);
        fechaHasta = formatDate(fechaHasta);
		
		const fechaEmitidoSeguro = formatDate(emitidoSeguro);

        const mesesVigencia = cantMonthsBetweenDates(fechaDesde, fechaHasta);

        return {
            cod: codSeguro,
            ramo: {
                nro: ramo,
                nombre: ramos_nombres[ramo],
            },
            nroPoliza: nroSeguro,
            nroEndoso: isEndoso ? nroEndoso : null,
            tipo: isEndoso ? ENDOSO : POLIZA,
            codEstado: codEstSeg,
            fechaDesde,
            fechaHasta,
            mesesVigencia,
			emitidoSeguro: fechaEmitidoSeguro,
            cancelada,
            detalleAsegurado,
            titular,
            cantDiasVigenciaPoliza,
            cantDiasRestastantesVigenciaPoliza: cantDiasVigeciaRestantesPoliza,
            cantDiasVigenciaEndoso,
            cantDiasVigenciaRestantesEndoso: cantDiasVigeciaRestantesEndoso,
            facturacion: {
                premio,
                prima,
                cantCuotas: cantidadCuotas,
                cuota1,
                cuotaX,
                sumaAseguradaTotal,
                metodoPago: tipoPago.split(/\s/).join(""),
            },
            productor: {
                nro: nroProductor,
                nombre: nombreProductor,
            },
            socio: {
                nro: nroSocio,
                nombre: titular,
                domicilio: {
                    pais: null,
                    provincia: socioProvincia,
                    localidad: socioLocalidad,
                    direccion: socioDireccion,
                    cp: null,
                    nro: socioDireccionNumero,
                    depto: socioDireccionDto,
                    piso: socioDireccionPiso,
                },
            },
            detailUrl: isEndoso
                ? `/seguros/${nroSeguro}/${nroEndoso}`
                : `/seguros/${nroSeguro}`,
        };
    });
};

export { adapterSegurosFromApi };
